import React, { useState } from "react";
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  const handleResetPassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setErrorMessage("Email is required.");
      return;
    }

    if (!emailRegex.test(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    try {
      await resetPassword(email);
      setErrorMessage("");
      setSuccessMessage("Password reset email sent. Please check your inbox.");
    } catch (error: any) {
      if (error.code === 'auth/user-not-found') {
        setErrorMessage('There is no user record corresponding to this email.');
      } else {
        setErrorMessage('An error occurred while resetting your password. Please try again.');
      }
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-br from-zinc-900 to-black text-white">
      <div className="flex flex-col items-center w-full max-w-md">
        {/* Centered logo above form */}
        <div className="mb-8">
          <img 
            src="/img/garagebot-logo-3.png" 
            alt="GarageBot" 
            className="h-32 w-64"
          />
        </div>
        
        <form
          onSubmit={handleResetPassword}
          className="bg-zinc-800 p-8 rounded-lg shadow-md w-full max-w-md"
        >
          <h1 className="text-2xl font-bold mb-4">Reset Password</h1>

          {errorMessage && (
            <div className="bg-red-500 text-white p-2 rounded mb-4">
              {errorMessage}
            </div>
          )}

          {successMessage && (
            <div className="bg-green-500 text-white p-2 rounded mb-4">
              {successMessage}
            </div>
          )}

          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium mb-1">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 rounded bg-zinc-700 border border-zinc-600 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white p-2 rounded font-medium"
          >
            Reset Password
          </button>

          <div className="mt-6 text-center">
            <p className="text-sm">
              Remember your password?
              <a href="/signin" className="text-emerald-500 hover:underline ml-1">
                Sign In
              </a>
            </p>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;